import { AnalyticsService } from './../../services/analytics.service';
import { Component, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-bestwallet',
    templateUrl: './bestwallet.component.html',
    styleUrl: './bestwallet.component.scss',
    standalone: false
})
export class BestwalletComponent {
  isBw = false;
  post_presale_singular_link: string = environment.post_presale_singular_link;
  readonly modalRef = inject(BsModalRef);
  private readonly analyticsService = inject(AnalyticsService);

  constructor() {}

  handleSingularLinkClick(): void {
    this.analyticsService.vwoData('singular', { downloadBestwalletPlacement: 'Transaction success popup' });
  }
}
